import React from "react";
import { Helmet } from "react-helmet";
import { ItemGridDragDropTitleStyle } from "../../components/grid-drag-drop/ItemGridDragDropTitleStyle";
import { Grid, IconButton } from "@material-ui/core";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import { LightTooltip, Margin } from "../../styles/GlobalStyle";
import CachedOutlinedIcon from "@material-ui/icons/CachedOutlined";
import CloseIcon from "@material-ui/icons/Close";
import { DividerStyled } from "../../components/chat/styles/GeneralStyle";
import useDashboardViewController from "../../pages/dashboard/controllers/DashboardViewController";

export const WidgetVersion55 = () => {
  const { handleDeleteWidgets } = useDashboardViewController();

  const item = {
    i: "55",
    importScripts: [""],
    stringScripts: [""],
    onRefresh: `try{  const GEV_ENVIRONMENT=localStorage.getItem("environment") ?? "test"; const GEV_ERP_API_URL=GEV_ENVIRONMENT==="prod" ? "https://qerpapi.qyon.com" : GEV_ENVIRONMENT==="beta" ? "https://beta-qerpapi.qyon.com" : GEV_ENVIRONMENT==="dev" ? "http://localhost:85" : "https://test-qerpapi.qyon.com"; const GEV_ERP_API_TOKEN=GEV_ENVIRONMENT === "prod" ? "eVmDI3J6dCqvxDUyZv16Sr1KBDW0TTNKvZA4LCkY" : "eyJ0ZXN0ZSI6InJhZmFvbGluZG9zejEyMyJ9" ; const documentPanel=localStorage.getItem("documentPanel"); const GEV_getSalesStatus=async ()=>{const GEV_salesStatusData=await fetch( \`\${GEV_ERP_API_URL}/api/erp/vendas/vendas/v1/status?\${new URLSearchParams({empresa_cnpj: documentPanel,})}\`,{method: "GET", headers: new Headers({Authorization: GEV_ERP_API_TOKEN,}),}) .then((res)=>{if (res.ok){return res.json();}throw res.statusText;}) .catch((error)=>{console.error("Widget GE - Vendas, fetch error:", error); if (document.getElementById("GEV_fetchError")){document.getElementById("GEV_fetchError").style.display="flex"; document.getElementById("GEV_loaderAnimation").style.display="none";}}); return GEV_salesStatusData?.success ? GEV_salesStatusData.data : false;}; function numberUStoBR(number){return number.toLocaleString("pt-br",{minimumFractionDigits: 2, maximumFractionDigits: 2,});}const GEV_populateSales=async ()=>{try{let GEV_salesStatusReturn=await GEV_getSalesStatus(); if (GEV_salesStatusReturn && document.getElementById("GEV_content")){document.getElementById("GEV_currentDayTotal").innerHTML=numberUStoBR(GEV_salesStatusReturn.currentDay.total); document.getElementById("GEV_currentDayProfit").innerHTML=numberUStoBR(GEV_salesStatusReturn.currentDay.profit) + \` (\${numberUStoBR( GEV_salesStatusReturn.currentDay.profitPercentagem )})\`; document.getElementById("GEV_currentMonthHeader").innerHTML=GEV_capitalizeFirstLetter( GEV_salesStatusReturn.currentMonth.header ); document.getElementById("GEV_currentMonthTotal").innerHTML=numberUStoBR(GEV_salesStatusReturn.currentMonth.total); document.getElementById("GEV_currentMonthProfit").innerHTML=numberUStoBR(GEV_salesStatusReturn.currentMonth.profit) +\` (\${numberUStoBR( GEV_salesStatusReturn.currentMonth.profitPercentagem )})\`; document.getElementById("GEV_lastYearMonthHeader").innerHTML=GEV_capitalizeFirstLetter( GEV_salesStatusReturn.lastYearMonth.header ); document.getElementById("GEV_lastYearMonthTotal").innerHTML=numberUStoBR(GEV_salesStatusReturn.lastYearMonth.total); document.getElementById("GEV_lastYearMonthProfit").innerHTML=numberUStoBR(GEV_salesStatusReturn.lastYearMonth.profit) + \` (\${numberUStoBR( GEV_salesStatusReturn.lastYearMonth.profitPercentagem )})\`; document.getElementById("GEV_content").style.display="flex";}}catch (error){console.error("Widget GE - Vendas, populate error:", error); document.getElementById("GEV_fetchError").style.display="flex"; document.getElementById("GEV_content").style.display="none";}finally{if (document.getElementById("GEV_loaderAnimation")){document.getElementById("GEV_loaderAnimation").style.display="none";}}}; function GEV_capitalizeFirstLetter(string){return string.charAt(0).toUpperCase() + string.slice(1);}document.getElementById("GEV_loaderAnimation").style.display="block"; document.getElementById("GEV_fetchError").style.display="none"; document.getElementById("GEV_content").style.display="none"; try{GEV_populateSales();}catch (error){console.error("Widget GE - Vendas, error:", error); document.getElementById("GEV_fetchError").style.display="flex"; document.getElementById("GEV_loaderAnimation").style.display="none";}}catch(err){}`,
    refreshOnLoad: true,
  };

  return (
    <>
      {item.importScripts.map((script, index) => {
        return (
          <div key={`import_${index}`}>
            <Helmet>
              <script async src={script}></script>
            </Helmet>
          </div>
        );
      })}

      <ItemGridDragDropTitleStyle customStyle={item.headerStyle ?? {}}>
        <Grid item container justifyContent="space-between" alignItems="center">
          <Grid item flex={1}>
            <IconButton size="small">
              <DragIndicatorIcon style={{ fontSize: 18, marginRight: 5 }} />
            </IconButton>
            Vendas
          </Grid>
          <Grid item flex={1}>
            <Grid item container alignItems="center">
              <Margin top="7" />
              {item.onRefresh &&
                (() => {
                  if (item?.refreshOnLoad) {
                    setTimeout(() => {
                      try {
                        // eslint-disable-next-line no-eval
                        eval("try{" + item.onRefresh + "}catch(err){}");
                      } catch (error) {
                        console.error(error);
                      }
                    }, 1500);
                  }

                  return (
                    <Grid item flex={1}>
                      <LightTooltip title="Atualizar">
                        <CachedOutlinedIcon
                          style={{
                            fontSize: 18,
                            marginRight: 10,
                            cursor: "pointer",
                            color: "#636363",
                          }}
                          onClick={() => {
                            // Muito cuidado, o eval é perigoso - https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/eval
                            try {
                              // eslint-disable-next-line no-eval
                              eval("try{" + item.onRefresh + "}catch(err){}");
                            } catch (error) {
                              console.error(error);
                            }
                          }}
                        />
                      </LightTooltip>
                    </Grid>
                  );
                })()}
              <Grid item flex={1}>
                <LightTooltip title="Remover">
                  <CloseIcon
                    style={{
                      fontSize: 18,
                      cursor: "pointer",
                      color: "#636363",
                      marginRight: 10,
                    }}
                    onClick={() => handleDeleteWidgets(item)}
                  />
                </LightTooltip>
              </Grid>
            </Grid>
          </Grid>
          <DividerStyled style={{ width: "100%" }} />
        </Grid>
      </ItemGridDragDropTitleStyle>

      <div
        style={{
          height: `${"calc(100% - 65px)"}`,
          width: "100%",
        }}
      >
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;400&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/icon?family=Material+Icons+Round"
          rel="stylesheet"
        />
        <style>
          {`
          @keyframes GEV_spinner-grow {
            0% {
              transform: scale(0);
            }
            50% {
              opacity: 1;
              transform: none;
            }
          }
        `}
        </style>
        <div
          id="GEV_widget"
          style={{
            height: "100%",
            fontFamily: "'Roboto', sans-serif",
            position: "relative",
          }}
        >
          <div
            id="GEV_loaderAnimation"
            style={{
              color: "#0d6efd !important",
              display: "none",
              width: "5rem",
              height: "5rem",
              verticalAlign: "-0.125em",
              backgroundColor: "currentColor",
              borderRadius: "50%",
              opacity: 0,
              WebkitAnimation: "0.75s linear infinite GEV_spinner-grow",
              animation: "0.75s linear infinite GEV_spinner-grow",
              animationDuration: "1.5s",
              position: "absolute",
              top: "calc(50% - 2.5rem)",
              left: "calc(50% - 2.5rem)",
            }}
          ></div>
          <div
            id="GEV_fetchError"
            style={{
              position: "absolute",
              width: "calc(100% - 20px)",
              height: "100%",
              display: "none",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span
              className="material-icons-round"
              style={{ fontSize: "3em", margin: "8px" }}
            >
              error_outline
            </span>
            <p>
              Não foi possível carregar os dados
              <br />
              Tente novamente
            </p>
          </div>
          <div
            id="GEV_content"
            style={{
              display: "flex",
              alignItems: "end",
              height: "100%",
              width: "100%",
            }}
          >
            <span
              style={{
                height: "73%",
                width: "4px",
                marginRight: "4px",
                borderRadius: "2px",
                backgroundColor: "#0A73DB",
              }}
            ></span>
            <table
              style={{
                height: "100%",
                borderCollapse: "collapse",
                width: "100%",
              }}
            >
              <thead style={{ height: "25%" }}>
                <tr>
                  <th
                    style={{
                      boxSizing: "border-box",
                      borderBottom: "1px solid #1477D8",
                      padding: "0 8px",
                    }}
                  ></th>
                  <th
                    style={{
                      boxSizing: "border-box",
                      borderBottom: "1px solid #1477D8",
                      padding: "0 8px",
                      textAlign: "right",
                    }}
                  >
                    R$ Total
                  </th>
                  <th
                    style={{
                      boxSizing: "border-box",
                      borderBottom: "1px solid #1477D8",
                      padding: "0 8px",
                      textAlign: "right",
                    }}
                  >
                    R$ Líquido (%)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      "rgba(0, 0, 0, 0.075)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                >
                  <th
                    scope="row"
                    style={{
                      padding: "0 8px",
                      boxSizing: "border-box",
                      borderBottom: "1px solid rgba(128, 128, 128, 0.5)",
                      textAlign: "left",
                    }}
                  >
                    Dia
                  </th>
                  <td
                    id="GEV_currentDayTotal"
                    title="Total de vendas bruto do dia atual"
                    style={{
                      padding: "0 8px",
                      boxSizing: "border-box",
                      borderBottom: "1px solid rgba(128, 128, 128, 0.5)",
                      textAlign: "right",
                    }}
                  >
                    -
                  </td>
                  <td
                    id="GEV_currentDayProfit"
                    title="Total vendas bruto - Total Custo (Percentual de lucro)"
                    style={{
                      padding: "0 8px",
                      boxSizing: "border-box",
                      borderBottom: "1px solid rgba(128, 128, 128, 0.5)",
                      textAlign: "right",
                    }}
                  >
                    -
                  </td>
                </tr>
                <tr
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      "rgba(0, 0, 0, 0.075)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                >
                  <th
                    id="GEV_currentMonthHeader"
                    scope="row"
                    style={{
                      padding: "0 8px",
                      boxSizing: "border-box",
                      borderBottom: "1px solid rgba(128, 128, 128, 0.5)",
                      textAlign: "left",
                    }}
                  >
                    -
                  </th>
                  <td
                    id="GEV_currentMonthTotal"
                    title="Total de vendas bruto do mês atual"
                    style={{
                      padding: "0 8px",
                      boxSizing: "border-box",
                      borderBottom: "1px solid rgba(128, 128, 128, 0.5)",
                      textAlign: "right",
                    }}
                  >
                    -
                  </td>
                  <td
                    id="GEV_currentMonthProfit"
                    title="Total vendas bruto - Total Custo (Percentual de lucro)"
                    style={{
                      padding: "0 8px",
                      boxSizing: "border-box",
                      borderBottom: "1px solid rgba(128, 128, 128, 0.5)",
                      textAlign: "right",
                    }}
                  >
                    -
                  </td>
                </tr>
                <tr
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      "rgba(0, 0, 0, 0.075)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                >
                  <th
                    id="GEV_lastYearMonthHeader"
                    scope="row"
                    style={{
                      padding: "0 8px",
                      boxSizing: "border-box",
                      borderBottom: "1px solid rgba(128, 128, 128, 0.5)",
                      textAlign: "left",
                    }}
                  >
                    -
                  </th>
                  <td
                    id="GEV_lastYearMonthTotal"
                    title="Total de vendas bruto do mês correspondente no último ano"
                    style={{
                      padding: "0 8px",
                      boxSizing: "border-box",
                      borderBottom: "1px solid rgba(128, 128, 128, 0.5)",
                      textAlign: "right",
                    }}
                  >
                    -
                  </td>
                  <td
                    id="GEV_lastYearMonthProfit"
                    title="Total bruto - Total Custo (Percentual de lucro)"
                    style={{
                      padding: "0 8px",
                      boxSizing: "border-box",
                      borderBottom: "1px solid rgba(128, 128, 128, 0.5)",
                      textAlign: "right",
                    }}
                  >
                    -
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {item.stringScripts &&
        item.stringScripts.map((script, index) => {
          return (
            <div key={`script_${index}`}>
              <Helmet>
                <script async>{script}</script>
              </Helmet>
            </div>
          );
        })}
    </>
  );
};
